import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Changepassword from "./pages/Change-password";
import Customers from "./pages/Customers";
import Dashboard from "./pages/Dashboard";
import Managedrivers from "./pages/Drivers";
import Error from "./pages/ErrorPage/Error";
import InvalidToken from "./pages/ExtraScreen/InvalidToken";
import Thankyou from "./pages/ExtraScreen/Thankyou";
import Forgotpassword from "./pages/Forgot-password";
import GiftCards from "./pages/Gift-Card-Management";
import LastLocation from "./pages/LastLocation/GoogleMapWithMarkers";
import Login from "./pages/Login";
import Manageorders from "./pages/Manage-orders";
import Manageprices from "./pages/Price";
import PrivacyPolicy from "./pages/PrivacyPolicies";
import ResetPassword from "./pages/Reset-password";
import Manageservicearea from "./pages/Service-area";
function App() {
    return (
        <Router>
            <Routes>
                <Route exact path="/" element={<Login />} />
                <Route path="/forgot-password" element={<Forgotpassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/thank-you" element={<Thankyou />} />
                <Route path="/invalid-token" element={<InvalidToken />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/manage-orders" element={<Manageorders />} />
                <Route path="/customers" element={<Customers />} />
                <Route path="/manage-drivers" element={<Managedrivers />} />
                <Route path="/manage-service-area" element={<Manageservicearea />} />
                <Route path="/manage-price" element={<Manageprices />} />
                <Route path="/change-password" element={<Changepassword />} />
                <Route path="/last-location" element={<LastLocation />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/manage-gift-card" element={<GiftCards />} />
                {/* <Route exact path="*" element={<Login />} /> */}
                <Route exact path="*" element={<Error />} />
            </Routes>
        </Router>        
        
    );
}
 
export default App;